import { DialogActions, DialogContent, Skeleton, Stack } from '@mui/material';

export function NoteFormPlaceholder() {
  return (
    <>
      <DialogContent dividers sx={{ py: 3, px: 2 }}>
        <Stack spacing={3}>
          <Skeleton height={56} />
          <Skeleton height={56} />
          <Skeleton height={140} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Skeleton width={90} height={36} />
        <Skeleton width={90} height={36} />
      </DialogActions>
    </>
  );
}
